import Image from "next/image";

import { ChevronRight } from "lucide-react";

import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@repo/ui/components/ui/card";
import { Link } from "@repo/ui/navigation";

export interface Benefit {
  readonly imageSrc: string;
  readonly alt: string;
  readonly title: string;
  readonly description: string;
  readonly link: string;
  readonly linkText?: string;
}

export default function BenefitCard({
  imageSrc,
  alt,
  title,
  description,
  link,
  linkText,
}: Benefit) {
  return (
    <Card
      className="flex h-full flex-col gap-2 py-0"
      data-testid={`alliance-benefit-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="relative h-52 w-full">
        <Image src={imageSrc} alt={alt} fill className="rounded-t-lg object-cover" />
      </div>
      <CardHeader className="text-center">
        <CardTitle className="text-brand-blue" dangerouslySetInnerHTML={{ __html: title }} />

        <CardDescription
          className="text-brand-gray"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </CardHeader>
      <CardFooter className="mx-3 flex justify-center border-t border-gray-200 px-4 !pt-2 pb-2">
        <Link
          href={link}
          className="text-brand-cyan hover:text-brand-blue flex items-center hover:underline"
        >
          {linkText || "See more"}
          <ChevronRight className="ml-1 inline-block" size={16} />
        </Link>
      </CardFooter>
    </Card>
  );
}
